module.exports = __webpack_public_path__ + "media/images/contractor-img-e31c26c3dda89606ea9323f5471177ed.jpg";